<!-->┌──────────────────────────────────────────────────────────────────────────────────────┐<- ->
<- ->│                                  Transition Expand                                   │<- ->
<- ->└──────────────────────────────────────────────────────────────────────────────────────┘<--->
<template>
    <transition appear name="expand" @enter="enter" @afterEnter="afterEnter" @leave="leave">
        <div :style="style" :class="[{'transition-expand': 1, 'fade-in-out': fade}, classList]">
            <div :class="[{'transition-expand-content':1, 'transition-expand-fade': fade}, containerClass]">
                <slot />
            </div>
        </div>
    </transition>
</template>
<style scoped>
    .transition-expand.expand-leave-active.fade-in-out {
        transition-delay: .25s;
    }
</style>
<script>
    export default {
        abstract: true,

        name: 'TransitionExpand',
        props: ['duration', 'fade', 'classList', 'containerClass'],
        // 'containerClass' prop is used to add a custom class to the direct-parent container of the slotted content

        computed: {
            style() {
                return {
                    '-moz-transition-duration': this.duration,
                    '-webkit-transition-duration': this.duration,
                    'transition-duration': this.duration,
                }
            }
        },
        methods: {
            enter(el) {
                //get element width
                const width = getComputedStyle(el).width;

                //set explicit styles in order to not affect other elements
                el.style.width = width;
                el.style.position = 'absolute';
                el.style.visibility = 'hidden';
                el.style.height = 'auto';

                //get element height
                const height = getComputedStyle(el).height;

                //unset styles previously set above
                el.style.width = null;
                el.style.position = null;
                el.style.visibility = null;
                el.style.height = 0;

                //force repaint
                getComputedStyle(el).height;

                //trigger animation
                setTimeout(() => {
                    el.style.height = height;
                });
            },
            afterEnter(el) {
                //restore element height
                el.style.height = 'auto';
            },
            leave(el) {
                //get element height
                const height = getComputedStyle(el).height;

                //set explicit height
                el.style.height = height;

                //force repaint
                getComputedStyle(el).height;

                //trigger animation
                setTimeout(() => {
                    el.style.height = 0;
                });
            }
        }
    }
</script>
